import React from "react";
import { Empty, Button, Typography, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface EmptyStateProps {
  resource?: string;
  title?: string;
  description?: string;
  createRoute?: string;
  showCreateButton?: boolean;
  image?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  resource,
  title,
  description,
  createRoute,
  showCreateButton = true,
  image,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const defaultTitle = resource
    ? t("emptyState.noItems", {
        resource: t(`navigation.${resource}`, resource),
      })
    : t("emptyState.noData");

  const defaultDescription = resource
    ? t("emptyState.createFirst", {
        resource: t(`navigation.${resource}`, resource),
      })
    : t("emptyState.noDataDescription");

  const resolvedCreateRoute =
    createRoute || (resource ? `/${resource}/create` : undefined);

  return (
    <div className="fade-in" style={{ padding: "32px 0" }}>
      <Empty
        image={image || Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <Space direction="vertical" size={4} style={{ textAlign: "center" }}>
            <Typography.Text strong style={{ fontSize: 16 }}>
              {title || defaultTitle}
            </Typography.Text>
            <Typography.Text type="secondary">
              {description || defaultDescription}
            </Typography.Text>
          </Space>
        }
      >
        {showCreateButton && resolvedCreateRoute && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate(resolvedCreateRoute)}
          >
            {t("buttons.create")}
          </Button>
        )}
      </Empty>
    </div>
  );
};
